import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    HR_PRODUCT,
    HR_PRODUCT_LIST,
    HR_SUPPLIER,
    HR_CATEGORY,
    HR_COUNTRY,
    HR_STATUS,
    HR_LIST,
    HR_ADD,
    HR_EDIT,
    HR_UPLOAD_SET
} from "../../actions";

import {
    HRProductSuccess,
    HRProductError,
    HRProductListSuccess,
    HRProductListError,
    HRSupplierSuccess,
    HRSupplierError,
    HRCategorySuccess,
    HRCategoryError,
    HRCountrySuccess,
    HRCountryError,
    HRListSuccess,
    HRListError,
    HRAddSuccess,
    HRAddError,
    HREditSuccess,
    HREditError,
    HRUploadSetSuccess,
    HRUploadSetError
} from '../../actions';


export function* watchHRProduct() {
    yield takeEvery(HR_PRODUCT, onHRProduct);
}

export function* watchHRProductList() {
    yield takeEvery(HR_PRODUCT_LIST, onHRProductList);
}

export function* watchHRSupplier() {
    yield takeEvery(HR_SUPPLIER, onHRSupplier);
}

export function* watchHRCategory() {
    yield takeEvery(HR_CATEGORY, onHRCategory);
}

export function* watchHRCountry() {
    yield takeEvery(HR_COUNTRY, onHRCountry);
}

export function* watchHRStatus() {
    yield takeEvery(HR_STATUS, onHRStatus);
}

export function* watchHRList() {
    yield takeEvery(HR_LIST, onHRList);
}

export function* watchHRAdd() {
    yield takeEvery(HR_ADD, onHRAdd);
}

export function* watchHREdit() {
    yield takeEvery(HR_EDIT, onHREdit);
}

export function* watchHRUploadSet() {
    yield takeEvery(HR_UPLOAD_SET, onHRUploadSet);
}
function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onHRProductAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/product', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHRProductListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/productlist', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHRSupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHRCategoryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/category', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHRCountryAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/country', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHRStatusAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/status', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onHRListAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/list', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
}

const onHRAddAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/add', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHREditAsync = async (data) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'healthRegistration/edit', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(data.payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onHRUploadSetAsync = async (file) => {
    var storageRef = storage.ref();
    let filename = file.name;
    return await new Promise((success, reject) => {
        var uploadTask = storageRef.child(storagePath + '/healthregistration/' + filename).put(file);
        uploadTask.on('state_changed',
            function (snapshot) {
                var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log('Upload is ' + progress + '% done');
            },
            function (error) {
                reject({ name: filename, original: file.name, message: error.code, url: '', type: file.type, size: file.size, path: 'healthregistration/' })
            },
            function () {
                uploadTask.snapshot.ref.getDownloadURL().then(function (downloadURL) {
                    success({ message: 'success', name: filename, original: file.name, url: downloadURL });
                });
            });
    });
};

function* onHRProduct(data) {
    try {
        const response = yield call(onHRProductAsync, data.payload);
        yield put(HRProductSuccess(response.data));
    } catch (error) {
        yield put(HRProductError(error));
    }
}

function* onHRProductList(data) {
    try {
        const response = yield call(onHRProductListAsync, data.payload);
        yield put(HRProductListSuccess(response.data));
    } catch (error) {
        yield put(HRProductListError(error));
    }
}

function* onHRSupplier(data) {
    try {
        const response = yield call(onHRSupplierAsync, data.payload);
        yield put(HRSupplierSuccess(response.data));
    } catch (error) {
        yield put(HRSupplierError(error));
    }
}

function* onHRCategory(data) {
    try {
        const response = yield call(onHRCategoryAsync, data.payload);
        yield put(HRCategorySuccess(response.data));
    } catch (error) {
        yield put(HRCategoryError(error));
    }
}

function* onHRCountry(data) {
    try {
        const response = yield call(onHRCountryAsync, data.payload);
        yield put(HRCountrySuccess(response.data));
    } catch (error) {
        yield put(HRCountryError(error));
    }
}

function* onHRStatus(data) {
    try {
        const response = yield call(onHRStatusAsync, data.payload);
        yield put(HRStatusSuccess(response.data));
    } catch (error) {
        yield put(HRStatusError(error));
    }
}

function* onHRList(data) {
    try {
        const response = yield call(onHRListAsync, data.payload);
        yield put(HRListSuccess(response.data));
    } catch (error) {
        yield put(HRListError(error));
    }
}

function* onHRAdd(data) {
    try {
        const response = yield call(onHRAddAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(HRAddSuccess(response.data));
    } catch (error) {
        yield put(HRAddError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onHREdit(data) {
    try {
        const response = yield call(onHREditAsync, data);
        if (response.data.status === true) {
            NotificationManager.success(response.data.message, 'Exito', 3000, null, null, '');
        } else if (response.data.status === 'error') {
            NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
        }
        yield put(HREditSuccess(response.data));
    } catch (error) {
        yield put(HREditError(error));
        NotificationManager.error(response.data.message, 'Error', 3000, null, null, '');
    }
}

function* onHRUploadSet({ payload }) {
    const { file } = payload;
    try {
        const response = yield call(onHRUploadSetAsync, file);
        console.log("response" + JSON.stringify(response));
        if (response.message === 'success') {

            yield put(HRUploadSetSuccess(response));

        }
        else {
            yield put(HRUploadSetError(response));
        }
    } catch (error) {
        yield put(HRUploadSetError({ name: '', original: file.name, message: error, url: '', path: '' }))
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchHRProduct),
        fork(watchHRProductList),
        fork(watchHRSupplier),
        fork(watchHRCategory),
        fork(watchHRCountry),
        fork(watchHRStatus),
        fork(watchHRList),
        fork(watchHRAdd),
        fork(watchHREdit),
        fork(watchHRUploadSet)
    ]);
}